import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { Phase } from '@apps/pata/domain/models';
import { CompareLowerString2 } from '@common/services/utils.service';

import { IsStatus } from './is-status';
import { ExpirationDateStatus } from './expiration-date-status';

export const PataPhaseFeatureKey = 'phases';

// #region Phases
export type IPhaseState = EntityState<Phase>;
export const phasesAdapter: EntityAdapter<Phase> = createEntityAdapter({
    selectId: (phase: Phase): string => phase.phaseId,
    // sortComparer: CompareDateTime2<Phase>((phase: Phase): DateTime => phase.extremas.startingDate)
    sortComparer: CompareLowerString2<Phase>((phase: Phase): string => phase.phaseCode)
});
const phasesInitialState: IPhaseState = phasesAdapter.getInitialState({});
// #endregion

// #region Statuses
export type IIsStatusState = EntityState<IsStatus>;
export const isStatusesAdapter: EntityAdapter<IsStatus> = createEntityAdapter({
    selectId: (isStatus: IsStatus): string =>
        isStatus.projectNumber
});
const isStatusesInitialState: IIsStatusState = isStatusesAdapter.getInitialState({});
// #endregion

// #region ExpirationDates
export type IEdStatusState = EntityState<ExpirationDateStatus>;
export const edStatusesAdapter: EntityAdapter<ExpirationDateStatus> = createEntityAdapter({
    selectId: (expirationDateStatus: ExpirationDateStatus): string =>
        expirationDateStatus.projectNumber
});
const edStatusesInitialState: IEdStatusState = edStatusesAdapter.getInitialState({});
// #endregion

export interface IPataPhasesState {
    phases: IPhaseState;
    areLoading: IIsStatusState;
    areLoaded: IIsStatusState;
    areEmpty: IIsStatusState;
    areOups: IIsStatusState;
    expirationDates: IEdStatusState;
}

export const PataPhasesInitialState: IPataPhasesState = {
    phases: phasesInitialState,
    areLoading: isStatusesInitialState,
    areLoaded: isStatusesInitialState,
    areEmpty: isStatusesInitialState,
    areOups: isStatusesInitialState,
    expirationDates: edStatusesInitialState
};
